import { useContext } from "react";
import { SmartContext } from "../../../library/Core/SmartContext";
import { getCurrentInformationData } from "../../../library/Service/getCurrentStatus";

const CurrentInformation = (props: any) => {
    const { state } = useContext(SmartContext);

    const previewCardData = getCurrentInformationData(state);
    console.log("previewCardData", previewCardData);

    if (!previewCardData) return null;

    const { startYear, name, label } = previewCardData;

    return (
        <div className="impact-flow-detail border-success p-3 p-sm-4">
            <div className="row g-2">
                <div className="col">
                    <h3 className="font-18 font-600">Current Information Collected</h3>
                    <div className="row g-2">
                        {startYear && (
                            <div className="col-auto font-16 font-500">
                                <i className="icon-tick d-inline-block me-1"></i> {startYear} (Present)
                            </div>
                        )}
                        {name && (
                            <div className="col-auto font-16 font-500">
                                <i className="icon-tick d-inline-block me-1"></i> {label} {name}
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-auto">
                    <i className="bi bi-check-circle-fill fs-1 text-green"></i>
                </div>
            </div>
        </div>
    );
};

export default CurrentInformation;
